import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchMainEuropeanWebsites } from "../../redux/reducer/europaWebsitesMainReducer"; // Adjust path as necessary
import CustomLines from "../home/customLines";
import CustomBigText from "../sharedComponents/customBigText";
import CategoryCard from "./cardCategory";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const ChooseCategoryEuropeanSection = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigateWithLang = useLanguageNavigate();

  // Predefined order for categories
  const categoryOrder = [
    "Men",
    "Women",
    "Children",
    "Household supplies", 
    "Foodstuffs",
    "Camping and fishing",
  ];

  // Fetching state data for European websites
  const { mainEuropeanWebsites, status, error } = useSelector(
    (state) => state.websitesEuropean
  );
    const direction = useLanguageDirection();

  useEffect(() => {
    if (status === "idle" || !mainEuropeanWebsites.length) {
      dispatch(fetchMainEuropeanWebsites());
    }
  }, [dispatch, status, mainEuropeanWebsites.length]);

  // Sorting function to order the websites by predefined categories
  const sortByCategory = (websites) => {
    // Create a shallow copy of the websites array to avoid mutation
    const websitesCopy = [...websites];
    return websitesCopy.sort((a, b) => {
      const categoryA = a.title?.en || a.title?.ar || "";
      const categoryB = b.title?.en || b.title?.ar || "";

      // Check if the category exists in predefined order and sort accordingly
      const indexA = categoryOrder.indexOf(categoryA);
      const indexB = categoryOrder.indexOf(categoryB);

      return indexA - indexB;
    });
  };

  // Handling loading, error, and empty data states
  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p className="text-red-500">Error: {error}</p>;
  if (!mainEuropeanWebsites || mainEuropeanWebsites.length === 0)
    return <p>{t("NoWebsites")}</p>;

  const handleClick = (name, websites) => {
    if (!websites || websites.length === 0) {
      console.error(t("NoWebsites"));
      return;
    }
    const formattedName = name.toLowerCase().replace(/\s+/g, "-");
    navigateWithLang(`/category-europe/${encodeURIComponent(formattedName)}`, {
      state: { websites },
    });

    // Navigate to the desired path
    // navigate(`/category-europe/${encodeURIComponent(formattedName)}`, {
    //   state: { websites },
    // });

    // Force a full page reload
    window.location.reload();
  };

  // Sort the websites based on the predefined category order
  const sortedWebsites = sortByCategory(mainEuropeanWebsites);

  return (
    <div className="">
      <div className="flex flex-col items-center justify-center text-center max-container">
        <CustomLines />
        <CustomBigText title={t("categoryTitle")} />
        <div className="px-3 py-10 ">
          <div
            className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-6"
            dir={direction}
          >
            {sortedWebsites.map((website, index) => {
              const title =
                i18n.language === "ar" ? website.title?.ar : website.title?.en;
              return (
                <div
                  key={website._id || index} // Fallback to index if no id is available
                  className="flex flex-col items-center cursor-pointer"
                  // onClick={() => handleClick(website._id, website.subCategory)}
                  onClick={() => handleClick(website.title?.en, website.subCategory)}
                >
                  <CategoryCard
                    title={title || "Unnamed Website"}
                    image={website.img}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseCategoryEuropeanSection;
